import React, { useEffect, useState } from 'react';
import feedbackReview from '../../../assets/img/starbg.svg';
import { useStore } from '../../../hooks/useStore';
import appToast, { TOAST_TYPE } from '../../../utils/AppToast';
import APIServices from '../../../services/APIServices';
import { selectLoader } from '../../../utils/Helpers';
import { fetchEnumOptions } from 'utils/fetchData';
import { use } from 'react';

const OverrideModal = ({ overrideReasons = [], requestId = '', closeModal }) => {
  const [isLoading, setLoading] = useState(false);
  const [reasons, setReasons] = useState([]);
  const [selectedReasons, setSelectedReasons] = useState([]);
  const [note, setNote] = useState('');
  useEffect(() => {
    setReasons(overrideReasons);
  }, [overrideReasons]);

  const handleCheckboxChange = (id) => {
    setSelectedReasons((prev) => (prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]));
  };

  const handleSubmit = async () => {
    if (selectedReasons.length === 0) {
      appToast('Please select at least one reason', TOAST_TYPE.ERROR);
      return;
    }
    try {
      const payload = {
        note: note,
        decision: 'OVERRIDDEN', // or dynamic if needed
        overrideReasonIds: selectedReasons
      };

      selectLoader(true);

      const response = await APIServices.put(`/project-requests/${requestId}/override`, payload);

      appToast('Submitted successfully', TOAST_TYPE.SUCCESS);

      console.log(response);
      closeModal();
    } catch (error) {
      console.error(error);
      appToast('Something went wrong', TOAST_TYPE.ERROR);
    } finally {
      selectLoader(false);
    }
  };

  return (
    <div className="override-body">
      <p>
        You’re marking this request as in scope. Please explain why so we can improve future decisions and keep a clear
        record.
      </p>
      <div className="row">
        <div className="col-lg-12">
          <div className="delivery-box-Override">
            <div className="shareProgress-list">
              {reasons.map((reason) => (
                <div className="shareProgress-checkbox-cover" key={reason._id}>
                  <label className="custom-checkbox">
                    <input
                      type="checkbox"
                      checked={selectedReasons.includes(reason._id)}
                      onChange={() => handleCheckboxChange(reason._id)}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <p>{reason.name}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="override-formgroup">
        <label>Reason for override (optional)</label>
        <textarea
          placeholder="Explain why you are override this decision "
          value={note}
          onChange={(e) => setNote(e.target.value)}></textarea>
      </div>
      <div class="modal-footer">
        {/* <button class="cancel-btn ">No</button> */}
        <button class="delet-btn" onClick={handleSubmit} type="submit" disabled={isLoading}>
          {isLoading ? selectLoader(20) : 'Submit'}
        </button>
      </div>
    </div>
  );
};

export default OverrideModal;
